// Author panyurou
// Date 2023-12-11 17:22:09

class SithMesStoolRequireDateChangeHistory {
    constructor({
                    id = null,
                    poNumber = '',
                    poItemNumber = '',
                    prNumber = '',
                    prItemNumber = '',
                    oldValue = '',
                    newValue = '',
                    projectCode = '',
                    projectName = '',
                    materialNumber = '',
                    materialShortText = '',
                    vendorAccountNumber = '',
                    vendorNameZh = '',
                    prCreationDate = '',
                    networkNumber = '',
                    category = '',
                    costCenter = '',
                    orderNumber = '',
                    purchasingGroup = '',
                    source = '',
                    remark = ''
                }
                    = {}) {
        this.id = id;
        this.poNumber = poNumber;
        this.poItemNumber = poItemNumber;
        this.prNumber = prNumber;
        this.prItemNumber = prItemNumber;
        this.oldValue = oldValue;
        this.newValue = newValue;
        this.projectCode = projectCode;
        this.projectName = projectName;
        this.materialNumber = materialNumber;
        this.materialShortText = materialShortText;
        this.vendorAccountNumber = vendorAccountNumber;
        this.vendorNameZh = vendorNameZh;
        this.prCreationDate = prCreationDate;
        this.networkNumber = networkNumber;
        this.category = category;
        this.costCenter = costCenter;
        this.orderNumber = orderNumber;
        this.purchasingGroup = purchasingGroup;
        this.source = source;
        this.remark = remark;
    }
}

function newEntity() {
    return new SithMesStoolRequireDateChangeHistory();
}

function gridFields() {
    return Object.freeze([
        {
            key: 'poNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.poNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'poItemNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.poItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.prNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prItemNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.prItemNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'oldValue',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.oldValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'newValue',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.newValue',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectCode',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.projectCode',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'projectName',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.projectName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.materialNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'materialShortText',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.materialShortText',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorAccountNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.vendorAccountNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'vendorNameZh',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.vendorNameZh',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'prCreationDate',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.prCreationDate',
            sortable: true,
            form: {
                type: 'datepicker',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'networkNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.networkNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'category',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.category',
            sortable: true,
            form: {
                type: 'select',
                modalMultiSelectedType: 'string'
                , options: [
                    {value: '0', text: 'A'},
                    {value: '1', text: 'D'},
                    {value: '2', text: 'E'},
                    {value: '3', text: 'F'},
                    {value: '4', text: 'N'},
                    {value: '5', text: 'K'},
                    {value: '6', text: 'P'},
                    {value: '7', text: 'Q'}
                ]
            }
        },
        {
            key: 'costCenter',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.costCenter',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'orderNumber',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.orderNumber',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'purchasingGroup',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.purchasingGroup',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdByName',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.createdByName',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'createdTime',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.createdTime',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'wbsElement',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.wbsElement',
            sortable: true,
            form: {
                type: 'input',
                modalMultiSelectedType: 'string'
            }
        },
        {
            key: 'remark',
            label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.remark',
            sortable: true,
            isDetail: true,
            form: {
                type: 'textarea',
                modalMultiSelectedType: 'string'
            }
        }
    ])
}
const subviewVoConfigs = [
    {
        key: 'oldValue',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.oldValue',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'newValue',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.newValue',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByName',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.createdByName',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTime',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.createdTime',
        sortable: true,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.grid.remark',
        sortable: true,
        isDetail: true,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

const filter = {
    idFilter: '',
    idListFilter: [],
    poNumberFilter: '',
    poItemNumberFilter: '',
    prNumberFilter: '',
    prItemNumberFilter: '',
    oldValueFilter: '',
    newValueFilter: '',
    projectCodeFilter: '',
    projectNameFilter: '',
    materialNumberFilter: '',
    materialShortTextFilter: '',
    vendorAccountNumberFilter: '',
    vendorNameZhFilter: '',
    prCreationDateRteFilter: '',
    prCreationDateLteFilter: '',
    networkNumberFilter: '',
    categoryFilter: '',
    costCenterFilter: '',
    orderNumberFilter: '',
    purchasingGroupFilter: '',
    createdByNameFilter: '',
    createdTimeRteFilter: '',
    createdTimeLteFilter: '',
    sourceFilter: '',
    wbsElementFilter: ''
};

const fields = Object.freeze(Object.keys(newEntity()).map(i => 'entity.' + i));

const filterFields = Object.freeze(Object.keys(filter).map(i => 'filter.' + i));

const filterConfigs = [
    {
        key: 'poNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.poNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.poItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.prNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.prItemNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'oldValueFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.oldValue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'newValueFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.newValue',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCodeFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.projectCode',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectNameFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.projectName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.materialNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortTextFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.materialShortText',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.vendorAccountNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZhFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.vendorNameZh',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCreationDateRteFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.prCreationDateRte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCreationDateLteFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.prCreationDateLte',
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.networkNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'categoryFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.category',
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: 'A'},
                {value: '1', text: 'D'},
                {value: '2', text: 'E'},
                {value: '3', text: 'F'},
                {value: '4', text: 'N'},
                {value: '5', text: 'K'},
                {value: '6', text: 'P'},
                {value: '7', text: 'Q'}
            ]
        }
    },
    {
        key: 'costCenterFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.costCenter',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumberFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.orderNumber',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroupFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.purchasingGroup',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdByNameFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.createdByName',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeRteFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.createdTimeRte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'createdTimeLteFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.createdTimeLte',
        disabled: false,
        form: {
            type: 'datetimepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'wbsElementFilter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.filter.wbsElement',
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    }
];


const entityFormConfigs = [
    {
        key: 'poNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.poNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'poItemNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.poItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.prNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prItemNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.prItemNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'oldValue',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.oldValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'newValue',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.newValue',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectCode',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.projectCode',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'projectName',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.projectName',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.materialNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'materialShortText',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.materialShortText',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorAccountNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.vendorAccountNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'vendorNameZh',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.vendorNameZh',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'prCreationDate',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.prCreationDate',
        sortable: true,
        disabled: false,
        form: {
            type: 'datepicker',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'networkNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.networkNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'category',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.category',
        sortable: true,
        disabled: false,
        form: {
            type: 'select',
            modalMultiSelectedType: 'string'
            , showLabelSelectOne: true
            , options: [
                {value: '0', text: 'A'},
                {value: '1', text: 'D'},
                {value: '2', text: 'E'},
                {value: '3', text: 'F'},
                {value: '4', text: 'N'},
                {value: '5', text: 'K'},
                {value: '6', text: 'P'},
                {value: '7', text: 'Q'}
            ]
        }
    },
    {
        key: 'costCenter',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.costCenter',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'orderNumber',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.orderNumber',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'purchasingGroup',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.purchasingGroup',
        sortable: true,
        disabled: false,
        form: {
            type: 'input',
            modalMultiSelectedType: 'string'
        }
    },
    {
        key: 'remark',
        label: 'label.sith.stool.sithMesStoolRequireDateChangeHistory.entity.remark',
        sortable: true,
        disabled: false,
        form: {
            type: 'textarea',
            modalMultiSelectedType: 'string'
        }
    }
]

export {
    SithMesStoolRequireDateChangeHistory, newEntity, gridFields, fields, filterFields, filter, entityFormConfigs
    , filterConfigs

    , subviewVoConfigs
}
